import * as React from 'react';
import { createView, view } from '@sail/engine';
import { copyTokens } from './tokens';
import { columnPaddingVariants } from './ColumnPaddingVariants';
export const CopyHeaderLayout = createView(({ children, ...props })=>{
    return /*#__PURE__*/ React.createElement(view.header, props, children);
}, {
    variants: columnPaddingVariants,
    css: {
        paddingLeft: `${copyTokens.columnPaddingLeft}`,
        paddingRight: `${copyTokens.columnPaddingRight}`,
        position: 'relative',
        display: 'grid',
        rowGap: `${copyTokens.rowGap}`,
        maxWidth: 'var(--copyMaxWidth)'
    },
    defaults: {
        columnPaddingLeft: undefined,
        columnPaddingRight: undefined
    }
});

//# sourceMappingURL=CopyHeaderLayout.js.map